import PaymentSelectForm from "@/components/Form/PaymentSelectForm/index";
export default function PurchaseFormStep1({
  onSubmit,
  error,
  clearError,
  recaptchaSuccessV3,
  recaptchaCounterV2,
}) {
  return (
    <PaymentSelectForm
      mode="tvod"
      onSubmit={onSubmit}
      error={error}
      clearError={clearError}
      paymentText="内容の確認へ"
      recaptchaSuccessV3={recaptchaSuccessV3}
      recaptchaCounterV2={recaptchaCounterV2}
    />
  );
}
